import { apiRequest } from './apiClient';
import {
  EmpresaListQuery,
  EmpresaOperacional,
  EmpresaPapel,
  EmpresaPayload,
  EmpresaUpdatePayload,
  EmpresasPage,
} from '../types/empresa';

function queryString(query: EmpresaListQuery): string {
  const params = new URLSearchParams({
    page: String(query.page),
    pageSize: String(query.pageSize),
  });
  if (query.search?.trim()) params.set('search', query.search.trim());
  if (query.status) params.set('status', query.status);
  if (query.papel) params.set('papel', query.papel);
  return params.toString();
}

export function listarEmpresas(
  accessToken: string,
  query: EmpresaListQuery
): Promise<EmpresasPage> {
  return apiRequest<EmpresasPage>(`/empresas?${queryString(query)}`, accessToken);
}

export function criarEmpresa(
  accessToken: string,
  payload: EmpresaPayload
): Promise<EmpresaOperacional> {
  return apiRequest<EmpresaOperacional>('/empresas', accessToken, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function atualizarEmpresa(
  accessToken: string,
  empresaId: string,
  payload: EmpresaUpdatePayload
): Promise<EmpresaOperacional> {
  return apiRequest<EmpresaOperacional>(`/empresas/${empresaId}`, accessToken, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}

export function substituirPapeisEmpresa(
  accessToken: string,
  empresaId: string,
  papeis: EmpresaPapel[]
): Promise<EmpresaOperacional> {
  return apiRequest<EmpresaOperacional>(`/empresas/${empresaId}/papeis`, accessToken, {
    method: 'PUT',
    body: JSON.stringify({ papeis }),
  });
}
